import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../axiosinterceptor";

const EPISODE_IDENTIFIER_API = "/code_enhance_review_workflow_episode_identifier_filter";

const FILENAME_API = "/code_enhance_review_workflow_file_name_filter"
const SPECIALITIESFILTER = "/code_enhance_review_workflow_specialities_filter"
const PRINCIPALDIAGNOSIS  = "/code_enhance_review_workflow_principal_diagonsis_filter"
const DRG_API = "/code_enhance_review_workflow_drg_code_filter"
const PREDICTED_DRG1="/code_enhance_review_workflow_predicted_drg1_filters"
const PREDICTED_DRG2="/code_enhance_review_workflow_predicted_drg2_filters"
const HEALTHFUND_API  = "/code_enhance_review_workflow_health_fund_filters"
const AUDITRULECATEGORY_API = "/code_enhance_review_workflow_audit_category_filter"
const STATUS_API = "/code_enhance_review_workflow_status_filter"
const AUDITRULEREFERENCENO_API = "/code_enhance_review_workflow_audit_reference_no_filter"
const CODERNAME = "/code_enhance_review_workflow_coder_name_filter"
const PRINCIPAL_PROCEDURE_CODES_API = "/code_enhance_review_workflow_principal_procedure_codes_filter";
const MRN_OPTIONS_API="/code_enhance_review_workflow_medical_record_number_filters"
const CARE_TYPE_API = "/code_enhance_workflow_care_type_filter";
const AUDIT_RULE_USER_MESSAGE_API = "/code_enhance_workflow_user_message_filter";
const AUDIT_LONG_DESCRIPTION_API = "/code_enhance_workflow_long_description_filter";
const AUDIT_SHORT_DESCRIPTION_API = "/code_enhance_workflow_short_description_filter";

export const REQUEST_STATUS = Object.freeze({
  IDLE: "IDLE",
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
});

const initialState = {
   selectedColumnFiles: [],
  dropdowns: {
    episode: {data: [],page: 1,hasMore: true,status: REQUEST_STATUS.IDLE},
    file: {data: [],
      page: 1,hasMore: true,status: REQUEST_STATUS.IDLE},
    coder: {data: [],page: 1,hasMore: true,status: REQUEST_STATUS.IDLE},
    diagnosis: {data: [],page: 1,hasMore: true,status: REQUEST_STATUS.IDLE},
    drg: {data: [],page: 1,hasMore: true,status: REQUEST_STATUS.IDLE},
    healthfund: {data: [],page: 1,hasMore: true,status: REQUEST_STATUS.IDLE},
    specialities:{data: [],page: 1,hasMore: true,status: REQUEST_STATUS.IDLE},
    principalDiagnosis: {data: [],page: 1,hasMore: true,status: REQUEST_STATUS.IDLE},
    auditRuleCategory :{data: [],page: 1,hasMore: true,status: REQUEST_STATUS.IDLE},
    status :{data: [],page: 1,hasMore: true,status: REQUEST_STATUS.IDLE},
    auditRuleReferenceNo :{data: [],page: 1,hasMore: true,status: REQUEST_STATUS.IDLE},
    codername :{data: [],page: 1,hasMore: true,status: REQUEST_STATUS.IDLE},
    principalProcedureCodes: { data: [], page: 1, hasMore: true, status: REQUEST_STATUS.IDLE },
    predictedDrg1: { data: [], page: 1, hasMore: true, status: REQUEST_STATUS.IDLE },
    predictedDrg2: { data: [], page: 1, hasMore: true, status: REQUEST_STATUS.IDLE },
    mrn:{ data: [], page: 1, hasMore: true, status: REQUEST_STATUS.IDLE },
    careType: {data: [],page: 1,hasMore: true,status: REQUEST_STATUS.IDLE},
    auditUserMessage: {data: [],page: 1,hasMore: true,status: REQUEST_STATUS.IDLE},
    auditLongDescription: {data: [],page: 1,hasMore: true,status: REQUEST_STATUS.IDLE},
    auditShortDescription:{data:[],page:1,hasMore:true,status:REQUEST_STATUS.IDLE}
  },
};

export const getEpisodeIdentifiers = createAsyncThunk(
  "workflow/getEpisodeIdentifiers",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        EPISODE_IDENTIFIER_API,
        payload
      );

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  }
);

export const getFileNames = createAsyncThunk(
  "workflow/getFileNames",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(FILENAME_API, payload);

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  }
);
export const getSpecialitiesFilter = createAsyncThunk(
  "workflow/getSpecialitiesFilter",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(SPECIALITIESFILTER, payload);

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  }
);

export const getPrincipalDiagnosis = createAsyncThunk(
  "workflow/getPrincipalDiagnosis",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(PRINCIPALDIAGNOSIS, payload);

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  }
);
export const getDrg = createAsyncThunk(
  "workflow/getDrg",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(DRG_API, payload);

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  }
);
export const getPredictedDRG1 = createAsyncThunk(
  "workflow/getPredictedDRG1",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(PREDICTED_DRG1, payload);

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  }
);
export const getPredictedDRG2 = createAsyncThunk(
  "workflow/getPredictedDRG2",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(PREDICTED_DRG2, payload);

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  }
);
export const getHealthFund = createAsyncThunk(
  "workflow/getHealthFund",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(HEALTHFUND_API, payload);

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  }
);
export const getAuditRuleCategory = createAsyncThunk(
  "workflow/getAuditRuleCategory",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(AUDITRULECATEGORY_API, payload);

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  }
);
export const getStatus = createAsyncThunk(
  "workflow/getStatus",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(STATUS_API, payload);

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  }
);
export const getAuditRuleRefNo = createAsyncThunk(
  "workflow/getAuditRuleRefNo",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(AUDITRULEREFERENCENO_API, payload);

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  }
);
export const getCoderName = createAsyncThunk(
  "workflow/getCoderName",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(CODERNAME, payload);

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  }
);
export const getPrincipalProcedureCodes = createAsyncThunk(
  "workflow/getPrincipalProcedureCodes",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(PRINCIPAL_PROCEDURE_CODES_API, payload);
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  }
);
export const getMRNoptions = createAsyncThunk(
  "workflow/getMRNoptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(MRN_OPTIONS_API, payload);
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  }
);

export const getCareType = createAsyncThunk(
  "workflow/getCareType",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        CARE_TYPE_API,
        payload
      );

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  }
);

export const getAuidtRuleUserMessage = createAsyncThunk(
  "workflow/getAuidtRuleUserMessage",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        AUDIT_RULE_USER_MESSAGE_API,
        payload
      );

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  }
);

export const getLongDescription = createAsyncThunk(
  "workflow/getLongDescription",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        AUDIT_LONG_DESCRIPTION_API,
        payload
      );

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  }
);

export const getShortDescription = createAsyncThunk(
  "workflow/getShortDescription",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        AUDIT_SHORT_DESCRIPTION_API,
        payload
      );

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  }
);


const buildDropdownReducer = (builder, thunk, key, responseKey) => {
  builder
    .addCase(thunk.pending, (state) => {
      state.dropdowns[key].status = REQUEST_STATUS.LOADING;
    })

    .addCase(thunk.fulfilled, (state, action) => {
      const {
        [responseKey]: data,
        has_more,
        page_number,
      } = action.payload;

      state.dropdowns[key].status = REQUEST_STATUS.SUCCESS;

      state.dropdowns[key].data =
        page_number === 1
          ? data
          : [...state.dropdowns[key].data, ...data];

      state.dropdowns[key].page = page_number;
      state.dropdowns[key].hasMore = has_more;
    })

    .addCase(thunk.rejected, (state) => {
      state.dropdowns[key].status = REQUEST_STATUS.FAILURE;
    });
};



const EnhanceFiltersSlice = createSlice({
  name: "workflow",
  initialState,
  reducers: {
    setSelectedColumnFiles: (state, action) => {
    state.selectedColumnFiles = action.payload;
  },
  },

  extraReducers: (builder) => {
  buildDropdownReducer(
    builder,
    getEpisodeIdentifiers,
    "episode",
    "episode_identifiers"
  );

  buildDropdownReducer(
    builder,
    getFileNames,
    "file",
    "file_names"
  );

  buildDropdownReducer(
    builder,
    getSpecialitiesFilter,
    "specialities",
    "specialities"
  );

  buildDropdownReducer(
    builder,
    getPrincipalDiagnosis,
    "principalDiagnosis",
    "principal_daignosis_codes"
  );

  buildDropdownReducer(
    builder,
    getDrg,
    "drg",
    "drg_codes"
  );
  buildDropdownReducer(
    builder,
    getPredictedDRG1,
    "predictedDrg1",
    "predicted_drg1"
  );
  buildDropdownReducer(
    builder,
    getPredictedDRG2,
    "predictedDrg2",
    "predicted_drg2"
  );
  buildDropdownReducer(
    builder,
    getHealthFund,
    "healthfund",
    "health_funds"
  );
  buildDropdownReducer(
    builder,
    getAuditRuleCategory,
    "auditRuleCategory",
    "categories"
  );
   buildDropdownReducer(
    builder,
    getStatus,
    "status",
    "statuses"
  );
  buildDropdownReducer(
    builder,
    getAuditRuleRefNo,
    "auditRuleReferenceNo",
    "audit_ref_nos"
  );
  buildDropdownReducer(
    builder,
    getCoderName,
    "codername",
    "reviewers"
  );
  buildDropdownReducer(
  builder,
  getCareType,
  "careType",
  "care_type"
);
 buildDropdownReducer(
  builder,
  getAuidtRuleUserMessage,
  "auditUserMessage",
  "user_message"
);
 buildDropdownReducer(
  builder,
  getLongDescription,
  "auditLongDescription",
  "long_description"
);
buildDropdownReducer(
  builder,
  getShortDescription,
  "auditShortDescription",
  "short_description"
);
   buildDropdownReducer(builder, getPrincipalProcedureCodes, "principalProcedureCodes", "procedure_codes");
   buildDropdownReducer(builder, getMRNoptions, "mrn", "medical_record_numbers");
}
});
export const {setSelectedColumnFiles} = EnhanceFiltersSlice.actions;

export default EnhanceFiltersSlice.reducer;